import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = { class: "flex items-center justify-center w-full h-full z-50 fixed bg-black bg-opacity-80" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center space-x-1 text-sm text-white" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    fill: "none",
    class: "w-12 h-12 animate-spin",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Carregando dicionário ...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-40 mx-auto"
}, null, -1)
const _hoisted_6 = { class: "md:p-4 flex flex-row justify-center" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  class: "w-12 h-12 animate-spin",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z",
    fill: "currentColor",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "my-6 md:my-2 w-full flex flex-row justify-center"
}
const _hoisted_11 = { class: "p-4 w-full md:w-4/5 bg-white rounded-lg shadow-lg" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-md mx-auto p-4 md:mt-6 w-full md:w-4/5 text-center bg-white rounded-lg shadow-lg" }, [
  /*#__PURE__*/_createTextVNode(" Manabou está sendo desenvolvido com amor e carinho por "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://instalando.dev/",
    target: "_blank",
    class: "text-green-600 hover:text-green-500"
  }, "Vitor Soares (Instalando)"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

import { ref, onMounted } from 'vue'
import { useKuromojiStore } from '@/stores/kuromoji'
import { useSearchStore } from '@/stores/search'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const kuromoji = useKuromojiStore()
const searchStore = useSearchStore()

const keyword = ref('') // * A word or phrase to tokenize and search
const loading = ref(true)

const setDefaultKeyword = async () => {
  await searchStore.setDefaultKeyword(String(route.query.keyword || ''))
  keyword.value = searchStore.keyword
}

const search = async (keyword: string) => {
  router.push({ name: 'search', query: { keyword } })
  searchStore.setKeyword(keyword)
}

onMounted(async () => {
  await kuromoji.loadTokenizer()
  await setDefaultKeyword()
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
      [_vShow, loading.value]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          class: "w-full md:w-3/5 rounded-lg shadow-md p-4 text-gray-600",
          type: "text",
          placeholder: "Digite aqui!"
        }, null, 512), [
          [_vModelText, keyword.value]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (search(keyword.value)), ["stop"])),
          class: "ml-2 p-4 rounded-md shadow-md bg-green-500 hover:bg-green-600 text-white"
        }, " Pesquisar ")
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_view)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_12
    ])
  ], 64))
}
}

})